<template>
  <div class=" max-w-1440 max-xl:max-w-screen-lg px-6 lg:px-8 bg-bg-primary rounded-3xl p-16 max-xl:mx-0">
    <div class="mx-auto grid max-w-full grid-cols-1 gap-x-8 gap-y-16 max-lg:gap-y-6 lg:max-w-none lg:grid-cols-2">
      <div class="max-w-full flex flex-col justify-between">
        <h2 class="text-3xl font-bold tracking-tight text-newsletter-color sm:text-4xl">{{ translations[13862] }}</h2>
        <p class="my-8 text-lg leading-8 text-newsletter-color font-medium">{{ translations[13863] }}</p>
        <div class="flex flex-col items-start max-lg:mb-8">
          <div class="rounded-3xl hidden max-lg:block -translate-x-0 w-full">
            <img class="rounded-3xl mb-3 h-auto w-full" :src="'/src/images/newsletter.webp'" alt="newsletter" loading="lazy" width="638" height="192">
          </div>
        </div>
        <div class="klaviyo-form-YbmDZM klaviyo-form form-version-cid-2 [&_button]:!px-8"></div>
      </div>
      <dl class="lg:pt-2">
        <div class="flex flex-col items-start">
          <dt class="rounded-3xl max-lg:hidden">
            <img class="rounded-3xl mb-8 h-auto w-full" :src="'/src/images/newsletter.webp'" alt="newsletter" loading="lazy" width="638" height="192">
          </dt>
          <dd class="mt-4 font-medium text-newsletter-color" v-html="translations[13864]"></dd>
        </div>
      </dl>
    </div>
  </div>
</template>


<script lang="ts" setup>
  import { onBeforeMount, ref } from "vue";
  // import { storeToRefs } from 'pinia'
  import { translate } from '@/services/translation.service'

  // import { useTranslationStore } from "@/store/translationStore"
  // const TRANSLATION_STORE = useTranslationStore();
  // const { translationObject: TRANSLATION_OBJECT }: any = storeToRefs(TRANSLATION_STORE);

  interface Translations {
    [key: string]: string
  }
  const translations = ref<Translations>({})

  onBeforeMount(async () => {
    getTranslationsFromWindow()
  })

  const getTranslationsFromWindow = async () => {
    if ("translationIds" in window) {
      translations.value = <Translations>window.translationIds
      return
    }
    translations.value = await translate({ id: [13862, 13863, 13864] })
  }
</script>

<style lang="scss" scoped>

</style>
